import { EMPTY_CELL, formatReportDate } from '../format';

import type { ProductsReportProductType } from './types';

/** Product type column: the `CustomerDeviceKind` wire tokens as the AC spells them. Note this is
 *  **not** the catalog's own `ProductType` enum (DEVICE | BUNDLE) — a Bundle is never a row on
 *  this tab; its member devices and components are. */
export const PRODUCT_TYPE_LABEL: Record<ProductsReportProductType, string> = {
  device: 'Device',
  component: 'Component',
};

/** The Warranty Valid Till copy for a lapsed warranty. Exported because the page has to know which
 *  of the three outcomes it is looking at in order to colour it (`Error/900`, Figma 137:268360),
 *  and re-deriving that by string-matching this function's output would silently lose the red the
 *  day the copy changed. */
export const WARRANTY_EXPIRED_LABEL = 'Expired';

/** Warranty Valid Till has **three** states, not the two the AC names:
 *
 *  - a live date          → "DD MMM YYYY"
 *  - `isWarrantyExpired`  → the word "Expired" (rendered red by the page)
 *  - no date at all       → a hyphen
 *
 *  The third is reachable in production because `components.warranty_months` is nullable, and it
 *  must NOT read "Expired": a product with no warranty on record is not a product whose warranty
 *  has lapsed, and reporting it as such is a factual error in a report. Confirmed on the 112361
 *  stub. The null check runs first, so a null date flagged expired still reads "-". */
export function formatWarrantyValidTill(
  warrantyValidTill: string | null,
  isWarrantyExpired: boolean,
): string {
  if (!warrantyValidTill) return EMPTY_CELL;
  return isWarrantyExpired ? WARRANTY_EXPIRED_LABEL : formatReportDate(warrantyValidTill);
}
